import React from "react";
import { Outlet, Route, Routes as RRoutes, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import NotFound from "../components/NotFound";
import Confirm from "../screens/Confirm";
import RegisterConfirm from "../screens/Confirm/RegisterConfirm";
import { isSuperAdmin } from "../constants/user";
import Redirect from "../components/Redirect";

function WithNavigation({ children, user }) {
  return (
    <React.Fragment>
      <div
        className={`view-wrapper ${isSuperAdmin(user) ? "no-modules" : ""}`}>
        {children}
      </div>
    </React.Fragment>
  );
}

export default function Routes({ routes, user }) {
  return (
    <RRoutes>
      {routes.map((route, i) => {
        // map routes
        if (Array.isArray(route.routes)) {
          return (
            <Route
              key={route.key}
              path={route.path}
              exact={route.exact}
              element={route.component}
            >
              {route.routes.map((routeNestedOne) => {
                const { key, path, exact, component, routes } = routeNestedOne;
                let _path = typeof path === 'string' ? path.replace(route.path, '') : path;
                _path = _path[0] === '/' ? _path.substring(1) : _path

                if (Array.isArray(routes)) {
                  return (
                    <Route key={key} path={_path} exact={exact} element={component}>
                      {routes.map((routeNestedTwo) => {
                        const { key, path, exact, component } = routeNestedTwo;
                        let _path = typeof path === 'string' ? path.replace(routeNestedOne.path, '') : path;
                        _path = _path[0] === '/' ? _path.substring(1) : _path

                        return (
                          <Route key={key} path={_path} exact={exact} element={component} />
                        )
                      })}
                    </Route>
                  )
                }

                return (
                  <Route key={key} path={_path} exact={exact} element={component} />
                )
              })}
              <Route path="*" element={<NotFound />} />
            </Route>
          )
        }
        return (
          <Route
            key={route.key}
            path={route.path}
            exact={route.exact}
            element={route.component}
          />
        )
      })}
      <Route
        element={<Confirm />}
        exact={true}
        key="APP_CONFIRM"
        path="/:app/confirm"
      />
      <Route
        element={<RegisterConfirm />}
        exact={true}
        key="REGISTER_CONFIRM"
        path="/confirm/register"
      />
      <Route
        element={<RegisterConfirm />}
        exact={true}
        key="TIF_REGISTER_CONFIRM"
        path="/:app/confirm/register"
      />
      <Route path="*" element={<NotFound />} />
    </RRoutes>
  );
}

function Authenticated({ authenticated, ...rest }) {
  const { pathname } = useLocation();
  const hasPathname = (pathname && !!pathname.split("/app/")[1]);
  const isTif = typeof pathname === 'string' ? pathname.includes('tif') : false;

  return authenticated ? (
    <WithNavigation user={rest.user}>
      {/* App Layout */}
      <Outlet />
    </WithNavigation>
  ) : (
    <Redirect to={hasPathname ? isTif ? `/tif/login?fallback=${pathname}` : `/login?fallback=${pathname}` : '/'} />
  );
}

export const AuthenticatedRoutes = connect(
  ({ authentication: { authenticated, user } }) => ({ authenticated, user })
)(Authenticated);
